<template>
  <div class="finance-warpper">
    <div class="bg-white flex align-center">
      <div class="flex align-center margin-right-sm">
        <span>年度：</span>
        <el-select v-model="year" placeholder="请选择">
          <el-option
            v-for="item in yearList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <twoLevel @SearchInfo="SearchInfo"/>
    </div>
    <div class="bg-white margin-top-sm">
      <div class="flex align-center justify-between margin-bottom-xs">
        <h3>{{ yearChiose }}年1-12月各项收入明细</h3>
        <el-button type="primary" @click="incomeEdit" v-if="community && user.power === 7">编辑</el-button>
      </div>
      <el-table
        :data="income"
        border
        height="500"
        style="width: 100%">
        <el-table-column prop="xuhao" label="序号" fixed="left"></el-table-column>
        <el-table-column prop="xiangmu" label="社区" width="200px" fixed="left"></el-table-column>
        <el-table-column prop="heJi" label="合计"></el-table-column>
        <el-table-column prop="yiYue" label="1月"></el-table-column>
        <el-table-column prop="erYue" label="2月"></el-table-column>
        <el-table-column prop="sanYue" label="3月"></el-table-column>
        <el-table-column prop="siYue" label="4月"></el-table-column>
        <el-table-column prop="wuYue" label="5月"></el-table-column>
        <el-table-column prop="liuYue" label="6月"></el-table-column>
        <el-table-column prop="qiYue" label="7月"></el-table-column>
        <el-table-column prop="baYue" label="8月"></el-table-column>
        <el-table-column prop="jiuYue" label="9月"></el-table-column>
        <el-table-column prop="shiYue" label="10月"></el-table-column>
        <el-table-column prop="shiyiYue" label="11月"></el-table-column>
        <el-table-column prop="shierYue" label="12月"></el-table-column>
      </el-table>


    </div>
    <div class="bg-white margin-top-sm">
      <div class="flex align-center justify-between margin-bottom-xs">
        <h3>{{ yearChiose }}年1-12月各项支出明细</h3>
        <el-button type="primary" @click="expenditureEdit" v-if="community && user.power === 7">编辑</el-button>
      </div>

      <el-table
        :data="expenditure"
        border
        height="500"
        style="width: 100%">
        <el-table-column prop="xuhao" label="序号" fixed="left"></el-table-column>
        <el-table-column prop="xiangmu" label="社区" width="200px" fixed="left"></el-table-column>
        <el-table-column prop="heJi" label="合计"></el-table-column>
        <el-table-column prop="yiYue" label="1月"></el-table-column>
        <el-table-column prop="erYue" label="2月"></el-table-column>
        <el-table-column prop="sanYue" label="3月"></el-table-column>
        <el-table-column prop="siYue" label="4月"></el-table-column>
        <el-table-column prop="wuYue" label="5月"></el-table-column>
        <el-table-column prop="liuYue" label="6月"></el-table-column>
        <el-table-column prop="qiYue" label="7月"></el-table-column>
        <el-table-column prop="baYue" label="8月"></el-table-column>
        <el-table-column prop="jiuYue" label="9月"></el-table-column>
        <el-table-column prop="shiYue" label="10月"></el-table-column>
        <el-table-column prop="shiyiYue" label="11月"></el-table-column>
        <el-table-column prop="shierYue" label="12月"></el-table-column>
      </el-table>
    </div>
    <incomeEditDialog :year="yearChiose" :project="project" :projectName="projectName" :community="community"
                      :communityName="communityName" :incomeEditDialog="incomeEditDialog"
                      @cancelDialog="cancelDialog" :type="type"
    />

    <expenditureEditDialog :year="yearChiose" :project="project" :projectName="projectName" :community="community"
                           :communityName="communityName" :expenditureEditDialog="expenditureEditDialog"
                           @cancelDialog="cancelDialog" :type="type"
    />


  </div>
</template>

<script>
import incomeEditDialog from "@/views/pages/dialog/incomeEditDialog";
import expenditureEditDialog from "@/views/pages/dialog/expenditureEditDialog";
import twoLevel from "@/components/two-level";
import {optionList, year, zhDate} from "@/utils/utils";
import {getShuJuBiaoMingXi} from "@/api/caiwu";

export default {
  name: "month-finance",
  data() {
    return {
      yearList: optionList(true, year),
      year: zhDate(new Date(), 4),
      yearChiose: zhDate(new Date(), 4),
      project: 0,
      projectName: '',
      community: 0,
      communityName: '',
      income: [],
      expenditure: [],
      incomeEditDialog: false,
      expenditureEditDialog: false,
      type:1
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", this.$route.path, "财务管理 / 月度收支", false);
  },
  components: {
    twoLevel,
    incomeEditDialog,
    expenditureEditDialog
  },
  methods: {
    cancelDialog(val) {
      this.incomeEditDialog = false;
      this.expenditureEditDialog = false;
      this.getInfo();
    },
    //  收入编辑
    incomeEdit() {
      if (this.project && this.community) {
        this.incomeEditDialog = true
      } else {
        this.$message.info('请先选择社区及小区')
      }
    },
    //  支出编辑
    expenditureEdit(){
      if (this.project && this.community) {
        this.expenditureEditDialog = true
      } else {
        this.$message.info('请先选择社区及小区')
      }
    },
    //  获取收支明细
    async SearchInfo(val) {
      this.project = val.project
      this.projectName = val.projectName
      this.community = val.community
      this.communityName = val.communityName
      this.yearChiose = this.year
      if (this.project && this.community) {
        let _data = await getShuJuBiaoMingXi(this.year, this.project, this.community)
        this.income = _data.data[0].xiangmu_one
        this.expenditure = _data.data[1].xiangmu_one
      } else {
        this.$message.info('请先选择社区及小区')
      }

    },
    //  获取收支明细
    async getInfo() {
      let _data = await getShuJuBiaoMingXi(this.year, this.project, this.community)
      this.income = _data.data[0].xiangmu_one
      this.expenditure = _data.data[1].xiangmu_one
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.finance-warpper {

}
</style>
